import { serverSideTranslations } from 'next-i18next/serverSideTranslations'
import LandingPage from '@components/pages/home/LandingPage'

// const LandingPage = dynamic(
//   () => import('@components/pages/home/LandingPage'),
//   {
//     loading: () => <p>Loading...</p>,
//   }
// )

type Props = {}

export async function getStaticProps({ locale }: { locale: string }) {
  return {
    props: {
      ...(await serverSideTranslations(locale, [
        'common',
        'home',
        'authentication',
        'footer',
        'courses',
        'signUp',
        'home',
        'wishlistDropdown',
        'errors',
        'advantageous',
        'homeLanding/header',
        'homeLanding/features',
        'homeLanding/mustexist',
        'homeLanding/herosection',
        'homeLanding/safecontent',
        'homeLanding/trustedstudents',
        'becomeAuthorDetailsModal',
        'author',
        'reportProblem',
      ])),
    },
  }
}

const Home = ({}: Props) => {
  return <LandingPage />
}

export default Home
